// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-button[data-v-56f58b61]{padding-top:.45rem !important;padding-bottom:.45rem !important;width:100%;height:2.75rem}", ""]);
// Exports
module.exports = exports;
